<template>
    <wrap ref="wrap" :title="title">
        <CTable :head="head" :body="body">
            <!--
              自定义模版
              slot=head字段名
              slot-scope=数据索引
            -->
            <template slot-scope="{data}" slot="change_money">
              <span :style="{'color':data.change_money<0?'green' : data.change_money > 0 ? 'red' : ''}">{{data.change_money}}</span>
            </template>
            <template slot-scope="{data}" slot="change_type">
              <span>{{change_type[data.change_type]}}</span>
            </template>
            <template slot-scope="{data}" slot="addtime">
              <span>{{data.addtime | formatDate}}</span>
            </template>
        </CTable>
    </wrap>
</template>

<script>
  // qc15复用qc14
  import CTable from './table';
  import Wrap from "./wrap";
  import mixin from './mixin';
  import CSelect from "../c_select";
  import {mapState, mapActions} from 'vuex';

  export default {
    name: "QC22",
    mixins: [mixin],
    components: {Wrap, CTable, CSelect},
    computed: {
      ...mapState({
        d22: state => state.table.d22
      }),
      head () {
        return [
          {label: '余额', value: 'new_money'},
          {label: '变动金额', value: 'change_money'},
          {label: '类型', value: 'change_type'},
          {label: '备注', value: 'remark'},
          {label: '时间', value: 'addtime'},
        ];
      },
      body () {
        return this.d22.data;
      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(parseInt(value+"000"));
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    async mounted() {
      //await this.getData();
    },
    data() {
      return {
        change_type : {
          1: '结算',
          2: '上分',
          3: '在线上分',
          4: '下分',
          5: '投注',
          6: '佣金',
          7: '还原信用额'
        }
      }
    },
    methods: {
      ...mapActions('table', {
        load_d22_data: 'load_d22_data'
      }),
      loadAccountLog() {
        this.load_d22_data({
          offset: 0,
          limit: 50
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .wrap {
        display inline-block
        text-align center
        width 100px
    }

    .date {
        height: 34px;
        font-size: 14px;
        color: #000000;
        padding-bottom 10px;
        .item {
            float left
        }
        .select {
            width 140px
            height 32px
            border-radius 2px
            margin-right 10px
            background-color transparent
            border 1px solid #e0e0e0
        }
        .m10 {
            margin: 0 10px;
        }

        .search {
            display inline-block;
            height: 100%;
            color: #ffffff;
            vertical-align: top;
            line-height: 34px;
            width: 60px;
            text-align center;
            border-radius: 5px;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC22.vue